import React, { useEffect, useState } from 'react';
import SectionTitle from '../Common/SectionTitle';

const Busy = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Use process.env.PUBLIC_URL for image paths
  const imagePaths = {
    heroImg: `${process.env.PUBLIC_URL}/assets/img/details-4.png`,
    busyImg1: 'https://content.busy.in/wp-content/uploads/2024/03/financial-reporting-and-analytics.png',
    busyImg2: 'https://gdm-catalog-fmapi-prod.imgix.net/ProductLogo/525f62e4-bd5e-4ece-bf7b-0fb71f733ea3.jpeg',
    heroBgImg: `${process.env.PUBLIC_URL}/assets/img/hero-bg-2.jpg`,
    testimonialsBgImg: `${process.env.PUBLIC_URL}/assets/img/testimonials-bg.jpg`
  };
  
  // Set correct page title and scroll to top when component mounts
  useEffect(() => {
    document.title = "Busy Software | Digisoft";
    window.scrollTo(0, 0);
    
    // Force update header visibility
    const header = document.querySelector('.header');
    const topBar = document.querySelector('.top-bar');
    
    if (header) {
      header.style.display = 'flex';
      header.style.visibility = 'visible';
      header.style.opacity = '1';
      header.style.position = 'fixed';
    }
    
    if (topBar) {
      topBar.style.display = 'block';
      topBar.style.visibility = 'visible';
      topBar.style.opacity = '1';
    }

    // Check if mobile view
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      document.title = "Digisoft Services";
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  const busyFeatures = [
    {
      title: 'Busy',
      image: imagePaths.busyImg1,
      description: 'Busy is an easy-to-use, powerful Billing & Accounting Software for Invoicing, Complete Financial Accounting & Reporting, GST/VAT Compliance, Inventory Management and Advanced Automation. It is available on Desktop, Cloud and Mobile App.',
      ctaText: 'Get Demo'
    },
    {
      title: 'Busy on Mobile',
      image: imagePaths.busyImg2,
      description: 'Busy Mobile App is a powerful tool that connects with Busy Desktop Accounting Software to offer world-class features & experience to customers. It allows users to sync data on both systems, access data on the go and make it easy.',
      ctaText: 'Get Demo'
    },
    {
      title: 'Busy on Cloud',
      image: imagePaths.busyImg1,
      description: 'BUSY Online cloud-based nature provides businesses with unparalleled accessibility and convenience: Remote Access: Access your financial data from any location with an internet connection, breaking down geographical barriers and enabling remote work.',
      ctaText: 'Get Demo'
    }
  ];

  const busySolutions = [
    {
      title: 'Buy BusyPrime',
      description: 'Purchasing a complete BusyPrime license is a crucial step for streamlining your company\'s operations. You can get a strong business management tool that helps you increase productivity, efficiency, and wise decision-making by getting BusyPrime from Digisoft.',
      icon: 'cart-check'
    },
    {
      title: 'Renewal',
      description: 'The first step to streamlining your company\'s operations is to get a complete BusyPrime license. By acquiring BusyPrime from Digisoft, you gain access to a potent business management tool that supports increased productivity, efficiency, and well-informed decision-making.',
      icon: 'arrow-repeat'
    },
    {
      title: 'BusyPrime Rental',
      description: 'The best option for companies looking for flexibility and price is BusyPrime Rental. By renting BusyPrime from Digisoft, you can utilize all of the program\'s capabilities without making a sizable initial investment.',
      icon: 'calendar-check'
    }
  ];

  // Hero section background style
  const heroBackgroundStyle = {
    backgroundImage: `url(${imagePaths.heroBgImg})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.4,
    margin: 0,
    padding: 0
  };

  // CTA section background style
  const ctaBackgroundStyle = {
    backgroundImage: `url(${imagePaths.testimonialsBgImg})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    opacity: '40%'
  };

  return (
    <div id="details-busy" className="busy-page p-0">
      {/* Hero Section */}
      <section className="busy-hero pt-5 section dark-background position-relative">
        <div 
          style={heroBackgroundStyle}
        ></div>
        <div className="container py-5">
          <div className="row py-5 align-items-center">
            <div className="col-lg-6">
              <h1 className="display-5 fw-bold mb-4">Busy</h1>
              <p className="lead mb-4">
                BUSY is a robust and adaptable company management tool created to automate a variety of business processes. 
                It's a complete solution that gives companies the ability to increase production, efficiency, and decision-making. 
                Whether you run a startup, a developing company, or an established corporation, BUSY is made to suit your requirements.
              </p>
              <a href="#contact" className="btn btn-primary btn-lg">Get Started</a>
            </div>
            <div className="col-lg-6 text-center">
              <img 
                src={imagePaths.busyImg1} 
                alt="Busy Software" 
                className="img-fluid" 
                style={{ maxHeight: '400px' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Business Management Software Section */}
      <section className="business-management py-5 section light-background">
        <div className="container py-5">
          <SectionTitle 
            title="A Business Management Software" 
            description1="Complete" 
            description2="Solution" 
          />
          
          <div className="row mt-5 align-items-center">
            <div className="col-lg-6 mb-4 order-1 order-lg-1">
              <p className="lead">
                At Digisoft, we're dedicated to providing complete solutions that support organizations in their journey 
                towards digital transformation. Beyond TallyPrime, cloud computing, and SharePro, we provide a variety of services. 
                To support all of your business activities, we also provide reliable solutions, which is where BUSY comes into play.
              </p>
            </div>
            <div className="col-lg-6 mb-4 order-2 order-lg-2 text-center">
              <img 
                src={imagePaths.busyImg2} 
                alt="Busy Management Software" 
                className="img-fluid rounded shadow" 
                style={{ 
                  maxWidth: isMobile ? '80%' : '90%',
                  height: 'auto'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Busy Solutions Section */}
      <section className="busy-solutions py-5 section">
        <div className="container py-5">
          <SectionTitle 
            title="Busy Solutions" 
            description1="Our" 
            description2="Offerings" 
          />
          
          <div className="row mt-5">
            {busySolutions.map((solution, index) => (
              <div key={index} className="col-md-6 col-lg-4 mb-4">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="solution-icon mb-3 text-primary">
                      <i className={`bi bi-${solution.icon} fs-1`}></i>
                    </div>
                    <h3 className="card-title h4">{solution.title}</h3>
                    <p className="card-text text-muted">{solution.description}</p>
                    <a href="#contact" className="btn btn-outline-primary mt-2">Learn More</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Busy Features Section */}
      <section className="busy-features py-5 section light-background">
        <div className="container py-5">
          <SectionTitle 
            title="Busy Features" 
            description1="Our" 
            description2="Software" 
          />
          
          <p className="text-center mb-5 w-75 mx-auto">
            Synergistically architect plug-and-play without next-generation manufactured products. 
            Assertively develop synergistic networks.
          </p>
          
          <div className="row g-4 mt-2">
            {busyFeatures.map((feature, index) => (
              <div key={index} className="col-lg-4">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4 text-center">
                    <img 
                      src={feature.image} 
                      alt={feature.title} 
                      className="img-fluid mb-4" 
                      style={{ height: '180px', objectFit: 'contain' }}
                    />
                    <h3 className="h4 mb-3">{feature.title}</h3>
                    <p className="text-muted">{feature.description}</p>
                    <a href="#contact" className="btn btn-primary mt-3">{feature.ctaText}</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta py-5 section dark-background position-relative">
        <div 
          style={ctaBackgroundStyle} 
          className="position-absolute top-0 start-0 w-100 h-100"
        ></div>
        <div className="container py-5 text-center position-relative">
          <h2 className="mb-4">Ready to streamline your business with BUSY?</h2>
          <p className="mb-4 lead">Experience the power of comprehensive business management software.</p>
          <a href="#contact" className="btn btn-primary btn-lg">Contact Us Today</a>
        </div>
      </section>
    </div>
  );
};

export default Busy; 